export const getPouillesData = () => ({
  name: "Pouilles",
  country: "Italie",
  description: "Les Pouilles (Puglia) sont la plus grande région viticole du sud de l'Italie, s'étendant sur le talon de la botte italienne. Cette région méditerranéenne produit principalement des vins rouges puissants et des vins blancs aromatiques, avec une forte identité locale.",
  type: "region",
  mapAreas: [
    { region: "Pouilles", x: 60, y: 58, color: "#4B164C", size: 6 }
  ],
  statistics: {
    totalArea: "106,000 ha",
    production: "7.5 million hectolitres",
    appellations: "29 DOC et 4 DOCG",
    provinces: "6 provinces",
    exportPercentage: "40%"
  },
  characteristics: {
    climate: "Climat méditerranéen chaud et sec avec influence maritime",
    soil: "Sols de calcaire, argile et sable, très fertiles",
    viticulture: "Viticulture traditionnelle et moderne, cépages autochtones"
  },
  wineStyles: {
    red: "Vins rouges puissants et fruités, du léger au structuré",
    white: "Vins blancs secs et aromatiques, frais et complexes",
    rose: "Rosés fruités et équilibrés, parfaits pour l'apéritif",
    sweet: "Vins doux et passito, concentrés et complexes"
  },
  history: "La viticulture dans les Pouilles remonte à l'époque grecque et romaine. Au Moyen Âge, les monastères ont développé la viticulture. Le XXe siècle a vu l'émergence des appellations. Aujourd'hui, les Pouilles sont reconnues pour leurs vins de qualité et leurs cépages autochtones.",
  foodPairing: "Cuisine méditerranéenne, fruits de mer, viandes grillées, fromages, pâtes",
  subregions: {
    "salento": {
      name: "Salento",
      description: "Péninsule du Salento produisant des vins rouges puissants et des vins blancs aromatiques, avec une forte identité méditerranéenne.",
      characteristics: {
        climate: "Climat méditerranéen chaud et sec",
        soil: "Sols de calcaire et d'argile rouge",
        viticulture: "Viticulture traditionnelle, vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Primitivo", "Negroamaro", "Malvasia Nera"],
        white: ["Fiano", "Bombino Bianco", "Verdeca"]
      },
      wineStyles: {
        "primitivo-salento": "Vins rouges puissants et fruités",
        "negroamaro-salento": "Vins rouges structurés et tanniques",
        "fiano-salento": "Vins blancs secs et aromatiques"
      },
      foodPairing: "Viandes rouges, fruits de mer, fromages, cuisine méditerranéenne"
    },
    "murge": {
      name: "Murge",
      description: "Plateau des Murge produisant des vins rouges élégants et des vins blancs de qualité, avec une forte identité terroir.",
      characteristics: {
        climate: "Climat méditerranéen tempéré",
        soil: "Sols de calcaire et d'argile",
        viticulture: "Viticulture traditionnelle, rendements limités"
      },
      grapeVarieties: {
        red: ["Aglianico", "Montepulciano", "Bombino Nero"],
        white: ["Bombino Bianco", "Fiano", "Greco"]
      },
      wineStyles: {
        "aglianico-murge": "Vins rouges élégants et complexes",
        "bombino-bianco-murge": "Vins blancs secs et frais",
        "castel-del-monte": "Vins rouges et blancs de qualité"
      },
      foodPairing: "Viandes blanches, poissons, fromages, cuisine traditionnelle"
    },
    "gargano": {
      name: "Gargano",
      description: "Promontoire du Gargano produisant des vins blancs aromatiques et des vins rouges fruités, avec une forte identité maritime.",
      characteristics: {
        climate: "Climat méditerranéen avec influence maritime",
        soil: "Sols de calcaire et de sable",
        viticulture: "Viticulture traditionnelle, vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Nero di Troia", "Bombino Nero", "Montepulciano"],
        white: ["Bombino Bianco", "Fiano", "Greco"]
      },
      wineStyles: {
        "nero-di-troia-gargano": "Vins rouges fruités et équilibrés",
        "bombino-bianco-gargano": "Vins blancs secs et aromatiques",
        "cacc-e-mmitte": "Vins rouges et blancs de qualité"
      },
      foodPairing: "Fruits de mer, poissons, fromages, cuisine maritime"
    },
    "daunia": {
      name: "Daunia",
      description: "Région de la Daunia produisant des vins rouges et blancs de qualité, avec une forte identité montagneuse.",
      characteristics: {
        climate: "Climat méditerranéen avec influence montagneuse",
        soil: "Sols d'argile et de calcaire",
        viticulture: "Viticulture traditionnelle, vendanges manuelles"
      },
      grapeVarieties: {
        red: ["Montepulciano", "Aglianico", "Bombino Nero"],
        white: ["Bombino Bianco", "Fiano", "Greco"]
      },
      wineStyles: {
        "montepulciano-daunia": "Vins rouges fruités et équilibrés",
        "bombino-bianco-daunia": "Vins blancs secs et frais",
        "san-severo": "Vins rouges et blancs de qualité"
      },
      foodPairing: "Viandes blanches, poissons, fromages, cuisine traditionnelle"
    }
  }
}); 